//import { ErrorMessage } from "@hookform/error-message";
import { Grid, TextField, FormHelperText, useMediaQuery } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
// import InfoOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import "../../../styles.css";
import { useEffect, useState } from "react";
import TooltipComonent from "../../common/Tooltip";
import { useTheme } from "@mui/material/styles";

function TextQuestionComponent({ question }) {
  const {
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");

  question.rules.pattern = new RegExp(question.rules.pattern);
  return (
    <Grid
      item
      xs={12}
      sx={{
        mb: 2,
        ml: question?.isSuggested ? 4 : 0,
        backgroundColor: question?.isSuggested
          ? theme.palette.primary.nestedQuestionBackground
          : "",
        py: question?.isSuggested ? 2 : 0,
        px: question?.isSuggested ? 1.5 : 0,
        border: question?.isSuggested ? "1px solid #fff" : "none",
        borderRadius: question?.isSuggested ? 2 : 0,
        boxShadow: question?.isSuggested ? "0px 2px 4px rgba(0, 0, 0, 0.2)" : 0,
        cursor: question?.isSuggested ? "pointer" : "",
      }}
    >
      <Typography
        // variant="h6"
        // component="h1"
        display="flex"
        alignItems="center"
        justifyContent={
          question.question_info != null &&
          question.question_info.replace(/\s/g, "")?.length != 0
            ? `space-between`
            : `flex-start`
        }
sx={{
  fontWeight: 600,
  mb: 0.5,
  color: "text.primary",
}}        className="stepper-question"
      >
        {question.label}
        {question.rules.required && (
          <>
            &nbsp;<p style={{ color: "red" }}>*</p>
          </>
        )} 

        {question.question_info != null &&
        question.question_info.replace(/\s/g, "")?.length != 0 ? (
          <TooltipComonent message={question?.question_info} />
        ) : (
          <></>
        )}
      </Typography>
      <Controller
        control={control}
        rules={question.rules}
        name={question.questionName}
        render={({ field }) => (
          <TextField
            autoFocus={question?.autoFocus}
            {...field}
            onChange={(e, newValue) => {
              setValue(question.questionName, e.target.value);
              question?.isSuggested &&
                setValue(
                  `suggestedObject[${question.questionName}]`,
                  e.target.value
                );
              // console.log(
              //   "getCerti",
              //   getValues(`suggestedObject[${question.questionName}]`)
              // );
            }}
            size={isMobile?'small':'medium'}
            style={{ width: "100%" }}
            // size="small"
            placeholder={question.placeholder}
            variant="outlined"
            InputProps={question.InputProps}
          />
        )}
      />
      {errors[question.questionName]?.type === "required" && (
        // <p className={"errorMsg"}>{question.errorMsg}</p>
        <FormHelperText error className={"errorMsg"}>
          {question.errorMsg}
        </FormHelperText>
      )}
      {errors[question.questionName]?.type === "pattern" && (
        // <p className={"errorMsg"}>{question?.patternErrorMsg}</p>
        <FormHelperText error className={"errorMsg"}>
          {question?.patternErrorMsg}
        </FormHelperText>
      )}
      {/* <ErrorMessage message={"First name is required"} name={`${questionName}`} as={"text"} /> */}
    </Grid>
  );
}
export default TextQuestionComponent;
